import React from 'react';
import PageHero from '../../components/PageHero';
import './Nosotros.css';

const TEAM = [
  { name: 'Ing. Carlos Morales', role: 'Director Técnico Minero', spec: 'Ing. de Minas · Esp. Ventilación Subterránea', icon: '👨‍💼', area: 'Minería' },
  { name: 'Ing. Laura Vargas',   role: 'Coordinadora Ambiental',  spec: 'Ing. Ambiental · MSc Gestión Ambiental',    icon: '👩‍💼', area: 'Ambiental' },
  { name: 'Ing. Pedro Torres',   role: 'Esp. en Sostenimiento',   spec: 'Ing. Geológico · Esp. Geomecánica',          icon: '👨‍🔬', area: 'Minería' },
  { name: 'Ing. Ana Rodríguez',  role: 'Esp. Recursos Hídricos',  spec: 'Ing. Ambiental · Esp. Hidrología',           icon: '👩‍🔬', area: 'Ambiental' },
  { name: 'Ing. Jairo Ospina',   role: 'Esp. en Normativa Minera',spec: 'Ing. de Minas · Abogado Minero',             icon: '👨‍⚖️', area: 'Minería' },
  { name: 'Biol. Sandra Parra',  role: 'Especialista en Fauna',   spec: 'Bióloga · Esp. Biodiversidad Andina',        icon: '👩‍🌿', area: 'Ambiental' },
];

export default function Equipo() {
  return (
    <div>
      <PageHero
        label="Nosotros"
        title="Nuestro Equipo"
        subtitle="Profesionales altamente calificados, comprometidos con la excelencia técnica y la seguridad."
        variant="green"
        breadcrumbs={[{ label: 'Nosotros', path: '/nosotros' }, { label: 'Nuestro Equipo' }]}
      />

      <section className="section">
        <div className="container">
          <div className="divider divider--center" />
          <h2 className="section-title section-title--center anim-fade-up">Especialistas a su servicio</h2>
          <p className="section-lead section-lead--center anim-fade-up anim-delay-1" style={{marginBottom:'56px'}}>
            Cada proyecto es atendido por profesionales especializados en el área requerida.
          </p>
          <div className="team-grid">
            {TEAM.map((m, i) => (
              <div className={`team-card card card--elevated anim-fade-up anim-delay-${(i % 4) + 1}`} key={m.name}>
                <div className={`team-card__avatar team-card__avatar--${m.area === 'Minería' ? 'green' : 'blue'}`}>
                  {m.icon}
                </div>
                <span className={`tag tag--${m.area === 'Minería' ? 'green' : 'blue'}`} style={{margin:'0 auto 10px'}}>
                  {m.area}
                </span>
                <h3 className="team-card__name">{m.name}</h3>
                <p className="team-card__role">{m.role}</p>
                <p className="team-card__spec">{m.spec}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
